import type { Specimen } from "./types";

/** Reads every Specimen, each with its Species and Location already attached. */
export async function fetchSpecimens(signal?: AbortSignal): Promise<Specimen[]> {
  const response = await fetch("/v1/specimens", { signal });

  if (!response.ok) {
    throw new Error(`The API answered ${response.status}.`);
  }

  const body: { specimens: Specimen[] } = await response.json();
  return body.specimens;
}

/** Groups Specimens by Location, preserving the order the API returned. */
export function byLocation(specimens: Specimen[]): Array<{ location: Specimen["location"]; specimens: Specimen[] }> {
  const groups = new Map<string, { location: Specimen["location"]; specimens: Specimen[] }>();

  for (const specimen of specimens) {
    const group = groups.get(specimen.location.id);
    if (group) {
      group.specimens.push(specimen);
    } else {
      groups.set(specimen.location.id, { location: specimen.location, specimens: [specimen] });
    }
  }

  return [...groups.values()];
}
